import { useEffect, useRef } from 'react';

const OnInputDelay = () => {
  const ref = useRef<HTMLDivElement | null>(null);

  const getIdleTime = () => {
    if (!ref.current) return 0;
    return Number(ref.current.getAttribute('data-idle-time'));
  };

  const hasInteracted = () => {
    if (!ref.current) return;
    ref.current?.setAttribute('data-idle-time', '0');
  };

  useEffect(() => {
    const interval: NodeJS.Timer = setInterval(function () {
      if (!ref.current) return;
      const idleTime = getIdleTime();

      ref.current?.setAttribute('data-idle-time', (idleTime + 1000).toString());
    }, 1000);

    window.addEventListener('input', hasInteracted);
    return () => {
      window.removeEventListener('input', hasInteracted);
      clearInterval(interval);
    };
  }, []);

  return <div id="idle-time" hidden ref={ref} />;
};

export { OnInputDelay };
